import React from "react";
import fieldPropTypes from "./field-prop-types";

class ExpansionPanel extends React.Component {
  constructor(props) {
    super(props);
    this.state = { showBody: false };
  }

  onBodyChange = (event, title) => {
    const { checked } = event.target;
    const { field, appData } = this.props;
    appData.handleCheckboxClick(field.filterName, checked, title);
  };

  isChecked = ({ title }) => {
    const {
      field: { filterName },
      appData: { providerFilters }
    } = this.props;
    return providerFilters.filters[filterName].indexOf(title) !== -1;
  };

  buildBody = () => {
    const {
      field,
      components: { Checkbox }
    } = this.props;
    if (field.filterOptions) {
      return field.filterOptions.map(({ cellData }) => (
        // Todo: remove eslint-disable and add key prop to the component
        // eslint-disable-next-line react/jsx-key
        <Checkbox
          name={field.name}
          checked={this.isChecked(cellData)}
          label={cellData.title}
          style={{ marginRight: "5px", marginLeft: "10px" }}
          onChange={e => this.onBodyChange(e, cellData.title)}
        />
      ));
    }
  };

  extractSelectedOptions = ({ filterOptions, filterName }) => {
    const {
      appData: { providerFilters }
    } = this.props;
    const selectedOptions = filterOptions.filter(
      option =>
        !!providerFilters.filters[filterName].find(
          value => option.cellData.title === value
        )
    );
    if (selectedOptions.length === filterOptions.length) {
      return "(All)";
    }
    if (selectedOptions.length && selectedOptions.length === 1) {
      return `(${selectedOptions[0].cellData.title})`;
    } else if (selectedOptions.length && selectedOptions.length > 1) {
      return `(${selectedOptions.length})`;
    } else {
      return "";
    }
  };

  toggleExpansion = () => {
    this.setState(prevState => ({ showBody: !prevState.showBody }));
  };

  render() {
    const {
      field,
      components: { ExpansionPanel: ExpansionPanelView }
    } = this.props;
    const { filterHeader } = field;
    return (
      <ExpansionPanelView
        showBody={this.state.showBody}
        inlineHeader
        header={filterHeader}
        subtitle={this.extractSelectedOptions(field)}
        body={this.buildBody()}
        toggleExpansion={this.toggleExpansion}
      />
    );
  }
}

ExpansionPanel.propTypes = fieldPropTypes;

export default ExpansionPanel;
